<template>
  <div class="qua_ins_cate" >
    <el-divider content-position="left">待办事项分类列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入分类名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.category_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="category_name">
            <el-input
              v-model="categoryForm.category_name"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="incharge_id">
            <el-select
              v-model="categoryForm.incharge_id"
              multiple
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行角色" prop="exec_role">
            <el-select
              v-model="categoryForm.exec_role"
              multiple
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminRole"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in adminRoleOptions"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类描述" prop="desc">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryForm.desc"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="category_name">
            <el-input
              v-model="editCategoryForm.category_name"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="incharge_id">
            <el-select
              v-model="editCategoryForm.incharge_id"
              multiple
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行角色" prop="exec_role">
            <el-select
              v-model="editCategoryForm.exec_role"
              multiple
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminRole"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in adminRoleOptions"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类描述" prop="desc">
            <el-input
              size="mini"
              type="textarea"
              v-model="editCategoryForm.desc"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="editCategoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      max-height="650"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="category_name" label="分类名称"> </el-table-column>
      <el-table-column prop="incharge_name" label="负责人"> </el-table-column>
      <el-table-column prop="exec_role_name" label="执行角色">
      </el-table-column>
      <el-table-column prop="desc" label="分类描述"> </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScheduleCate',
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var categoryName = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var checkIncharge = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择负责人！'))
      }
      callback()
    }
    var checkExecRole = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择执行角色！'))
      }
      callback()
    }
    var checkDesc = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error('描述在500字以内！'))
      }
      callback()
    }
    return {

      searchArr: {
        category_id: ''
      },
      adminUserOptions: [],
      adminRoleOptions: [],
      npage: 1,
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: '',
      categoryForm: {
        categoryId: '',
        category_name: '',
        display: false,
        incharge_id: '',
        exec_role: '',
        desc: ''
      },
      editCategoryForm: {
        categoryId: '',
        category_name: '',
        display: false,
        incharge_id: '',
        exec_role: '',
        desc: ''
      },
      rules: {
        category_name: [
          {
            validator: categoryName,
            trigger: 'blur'
          }
        ],
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        incharge_id: [
          {
            validator: checkIncharge,
            trigger: 'blur'
          }
        ],
        exec_role: [
          {
            validator: checkExecRole,
            trigger: 'blur'
          }
        ],
        desc: [
          {
            validator: checkDesc,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
    this.loadAdminUser()
    this.loadAdminRole()
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadTable () {
      this.$axios
        .get('api/schedule/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.$axios
        .get('api/schedule/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            if (data.data.display === 1) {
              this.editCategoryForm.display = false
            } else {
              this.editCategoryForm.display = true
            }
            this.editCategoryForm.category_name = data.data.category_name
            let inchargeArr = data.data.incharge_id.split(',')
            let newInchargeArr = inchargeArr.map(function (item) {
              return Number(item)
            })
            this.editCategoryForm.incharge_id = newInchargeArr
            let execRoleArr = data.data.exec_role.split(',')
            let newexecRoleArr = execRoleArr.map(function (item) {
              return Number(item)
            })
            this.editCategoryForm.exec_role = newexecRoleArr
            this.editCategoryForm.desc = data.data.desc
            this.editCategoryForm.categoryId = data.data.id
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/schedule/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      this.npage = 1
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$refs.categoryForm.resetFields()
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/schedule/store', this.categoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.$refs.categoryForm.resetFields()
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/schedule/edit', this.editCategoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/schedule/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/schedule/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadAdminUser () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data
          }
        })
        .catch()
    },
    loadAdminRole () {
      this.$axios
        .get('api/schedule/getrole')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminRoleOptions = data.data
          }
        })
        .catch()
    }
  }
}
</script>
<style scoped>
.qua_ins_cate {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/schedule/ScheduleCate.vue